import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
interface ResendConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerEmail: string;
  customerPhone?: string;
  onResend: (sendSms: boolean) => void;
}
export function ResendConfirmationModal({
  isOpen,
  onClose,
  customerEmail,
  customerPhone,
  onResend
}: ResendConfirmationModalProps) {
  const [sendSms, setSendSms] = useState(false);
  const handleSend = () => {
    onResend(sendSms);
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Resend Order Confirmation" size="sm" footer={<>
          <Button variant="outline" onClick={onClose} data-id="element-100">
            Cancel
          </Button>
          <Button onClick={handleSend} data-id="element-101">Send Confirmation</Button>
        </>} data-id="element-99">
      <div className="space-y-4" data-id="element-102">
        <Input label="Customer Email" value={customerEmail} disabled helperText="Confirmation will be sent to this email address" data-id="element-103" />

        {customerPhone && <div className="flex items-center" data-id="element-104">
            <input type="checkbox" id="sendSms" checked={sendSms} onChange={e => setSendSms(e.target.checked)} className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded" data-id="element-105" />
            <label htmlFor="sendSms" className="ml-2 text-sm text-gray-700" data-id="element-106">
              Also send SMS to {customerPhone}
            </label>
          </div>}

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3" data-id="element-107">
          <p className="text-sm text-blue-800" data-id="element-108">
            The customer will receive a copy of their order confirmation with
            all order details.
          </p>
        </div>
      </div>
    </Modal>;
}